import { formatDateIso } from '../../dateTime';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchChannelPrograms } from './fetchChannelPrograms';

type GetChannelProgramsArgs = {
  channelId: number;
  day: string;
};

export function getChannelPrograms({ channelId, day }: GetChannelProgramsArgs) {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchChannelPrograms>>>(
    queryKeys.channelPrograms(channelId, formatDateIso(new Date(day))),
  );
}
